import { useLayoutEffect, useRef } from 'react';
import type { FieldControlProps } from './form-field';

export function Textarea({
  maxLength,
  count,
  readOnly,
  ...props
}: FieldControlProps & {
  maxLength?: number;
  count?(length: number, limit?: number): string;
  readOnly?: boolean;
}) {
  const ref = useRef<HTMLTextAreaElement>(null);
  const { value, onValueChange, ...input } = props;
  const text = typeof value === 'string' ? value : '';
  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) return;
    const height = Number.parseFloat(getComputedStyle(node).lineHeight);
    if (!Number.isFinite(height) || height <= 0) return;
    node.rows = 3;
    node.rows = Math.max(3, Math.min(12, Math.ceil(node.scrollHeight / height)));
  }, [text]);
  return (
    <>
      <span
        className="pc-field pc-field-md"
        data-state={props.disabled ? 'disabled' : readOnly ? 'readonly' : undefined}
      >
        <textarea
          {...input}
          ref={ref}
          className="pc-field-input pc-textarea"
          rows={3}
          readOnly={readOnly}
          value={text}
          onChange={(event) => onValueChange(event.currentTarget.value)}
        />
      </span>
      {count && (
        <span
          className="pc-form-count"
          data-tone={maxLength !== undefined && text.length > maxLength ? 'danger' : undefined}
        >
          {count(text.length, maxLength)}
        </span>
      )}
    </>
  );
}
